import * as types from '../actions/actionTypes'
import intialState from './initialState'

export default function environment (state = intialState.env, action) {
    switch (action.type) {
        case types.ENVIRONMENT:
            return {
                ...state,
                env: action.env
            }
        default:
            return state
    }
}
